<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      addText=""
      :count='count'
      :current="page"
      :disablePage='disablePage'
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem" >
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
         </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btn-wrap">
          <lk-button v-if="this.handlePermission('pharmaceuticalAdd')" class="mb8" type="primary" icon='md-add'  @click="addNew">添加</lk-button>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import tools from '../../services/tools';
import utils from '../../libs/utils';
import ReturnExpand from '../../components/tools/ReturnExpand.vue';
import goodsSearchItem from '../../components/goodsSearchItem.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'pharmaceuticalManagement',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    // eslint-disable-next-line vue/no-unused-components
    ReturnExpand,
    goodsSearchItem,
  },
  data() {
    return {
      disablePage: false,
      showAdd: false,
      showEdit: false,
      showDelete: false,
      showPrint: false,
      query: {
        storeIdList: [],
      },
      expandColumns: [
        {
          title: '序号',
          minWidth: 58,
          align: 'center',
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '门店名称',
          minWidth: 116,
          align: 'center',
          key: 'storeName',
        },
        {
          title: '库存',
          minWidth: 116,
          align: 'center',
          key: 'inventoryAmount',
          render: (h, { row }) => h('span', row.inventoryAmount ? row.inventoryAmount : 0),
        },
      ],
      columns: [
        {
          type: 'expand',
          width: 46,
          render: (h, { row }) => h(ReturnExpand,
            {
              props: {
                tableData: row.storeAndAmountList,
                columns: this.expandColumns,
              },
            }),
        },
        {
          title: '药品编码',
          minWidth: 116,
          key: 'serialCode',
        },
        {
          title: '通用名',
          minWidth: 116,
          key: 'approvedDrugNames',
        },
        {
          title: '商品名',
          minWidth: 116,
          key: 'goodsName',
        },
        {
          title: '随访模版ID',
          minWidth: 116,
          render: (h, { row }) => {
            const ids = row.visitTemplates.map(item => item.templateId);
            const idList = ids.filter(Boolean);
            return h('span', idList.join(','))
          },
        },
        {
          title: '随访模版名称',
          minWidth: 116,
          key: 'name',
          render: (h, { row }) => {
            const names = row.visitTemplates.map(item => item.templateName);
            const nameList = names.filter(Boolean); // 清楚‘’空字符串
            return h('span', nameList.length ? nameList.join(',') : '')
          },
        },
        {
          title: '创建时间',
          minWidth: 116,
          key: 'createTime',
        },
        {
          title: '修改时间',
          minWidth: 116,
          key: 'modifiedTime',
        },
        {
          title: '状态',
          key: 'pharmacyStatus',
          minWidth: 116,
          render: (h, params) => {
            const id = params.row.id;
            return h('lk-switch', {
              props: {
                size: 'large',
                value: params.row.pharmacyStatus === 1,
              },
              on: {
                'on-change': (flag) => {
                  const Message = flag ? '该药品已启用' : '该药品已禁用';
                  const data = {
                    id,
                    pharmacyStatus: flag ? 1 : 2,
                  };
                  tools.updatePharmacyStatus(data).then((res) => {
                    if (res.data.status === 200) {
                      this.$Message.success(Message);
                      this.getData();
                    } else {
                      this.$Message.error(res.data.error);
                      this.getData();
                    }
                  }).catch((err) => {
                    this.getData();
                    utils.handleError(err);
                  });
                },
              },
            },
            [
              h('span', {
                props: {
                },
                slot: 'open',
              }, '启用'),
              h('span', {
                props: {
                },
                slot: 'close',
              }, '禁用'),
            ]);
          },
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, { row }) => h('div', [
            this.handlePermission('pharmaceuticalEdit') ? h('lk-button', {
              props: {
                type: 'text',
                disabled: !row.status === 1,
              },
              on: {
                click: () => {
                  // 编辑时带个参数表示要请求接口且药品不可编辑
                  this.$router.push({ name: "pharmaceuticalEdit", query: {edit: 1,rowData: row} })
                },
              },
            }, '编辑') : '',
            this.handlePermission('pharmaceuticalDelete') ? h('lk-button', {
              props: {
                type: 'text',
                disabled: !row.status === 1,
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '是否删除该药学服务药品？',
                    onOk: () => {
                      tools.deletePharmacy({ id: row.id }).then((res) => {
                        if (res.data.status === 200) {
                          this.$Message.success('删除成功');
                        } else {
                          this.$Message.error(res.data.error);
                        }
                        this.getData();
                      }).catch((err) => {
                        this.getData();
                        utils.handleError(err);
                      });
                    },
                  });
                },
              },
            }, '删除'): null,
          ])

        },
      ],
      tableData: [],
    };
  },
  methods: {
    clear() {
      this.page = 1;
      this.size = 20;
      this.query = {
        storeIdList: [],
      };
    },
    addNew() {
      this.$router.push({name: "pharmaceuticalAdd", query: {edit: 0} })
    },
    // handleSearch() {
    //   this.getData();
    // },
    getData() {
      const params = utils.deepClone(this.query);
      params.page = this.page;
      params.size = this.size;
      tools.getPharmacyList(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = item;
            item.createTime = utils.exchangeTimeToSecond(item.createTime);
            item.modifiedTime = utils.exchangeTimeToSecond(item.modifiedTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
